import classes from './lane-risk-subheader.module.css'

type LaneRiskSubheaderProps = {
    label: string
    count: number
}

/** Compact time-band label within an operational lane (Today / Tomorrow / Later this week). */
export function LaneRiskSubheader({label, count}: LaneRiskSubheaderProps) {
    return (
        <div className={classes.subheader}>
            <span className={classes.label}>{label}</span>
            <span className={classes.count}>{count}</span>
        </div>
    )
}

export {classes as laneRiskSubheaderClasses}
